











































































































































import { useModalToggle } from '~/compositions/modal-toggle'
import {
  computed,
  onMounted,
  PropType,
  ref,
  toRefs,
  defineComponent
} from '@nuxtjs/composition-api'
import { useDep } from '~/compositions/dependency-container'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { ciAngleLeftLight } from '~/icons/source/solid/angle-left-light'
import AuditRequestService from '~/services/audits/AuditRequestService'
import { AuditRequest } from '~/models/audit/request'
import { useNamespacedStore } from '~/compositions/store'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import AuditRequestHistoryTimeline from '~/components/shared/audits/request/timeline/AuditRequestHistoryTimeline.vue'
import { ciAuditRequest } from '~/icons/source/regular/audit-request'
import { UPDATE_AUDIT_REQUEST } from '~/store/modules/shared/classifieds/view/mutation-types'
import AuditRequestEntry from '~/components/shared/classified/audits/AuditRequestEntry.vue'
import { capitalizeSentences } from '~/utils/string'
import CEmptyState from '~/components/shared/configurable/CEmptyState.vue'
import AuditRequestSelectedShopInfo from '~/components/shared/audits/request/AuditRequestSelectedShopInfo.vue'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import SelfAuditButton from '~/components/shared/classified/audits/SelfAuditButton.vue'

export default defineComponent({
  components: {
    AuditRequestSelectedShopInfo,
    CEmptyState,
    AuditRequestEntry,
    AuditRequestHistoryTimeline,
    SelfAuditButton
  },
  props: {
    classifiedId: { type: Number, required: true },
    loadedAuditRequest: {
      type: Object as PropType<AuditRequest | null>,
      required: false,
      default: null
    },
    userCanManageAudits: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props, { emit }) {
    const modalToggleFunc = useModalToggle()
    const { loadedAuditRequest } = toRefs(props)
    const { state } = useNamespacedStore(CLASSIFIED_VIEW_NS)
    const auditRequests = computed(() => {
      return state.auditRequests
    })

    const { commit, getters } = useNamespacedStore(CLASSIFIED_VIEW_NS)

    const isClassifiedOwner = computed(() => getters('isOwn'))

    const loading = ref(false)

    const auditRequestService = useDep(AuditRequestService)

    const userStore = useNamespacedStore<UserState>(USER_NS)
    const { getters: userGetters } = userStore

    const isAdmin = userGetters('isAdmin')

    const backButtonClicked = ref(false)
    const transitioning = ref(false)
    const swipeDirection = ref('swipe-left')

    const selectedAuditRequest = ref<AuditRequest | null>(
      loadedAuditRequest.value
    )

    const minimumPrice = computed(() => {
      return state.audits?.minimumPrice
    })

    const mainHash = computed(() => {
      if (loadedAuditRequest.value?.id) {
        return `audit-${loadedAuditRequest.value.id}`
      }
      return 'audits'
    })

    const goBack = () => {
      swipeDirection.value = 'swipe-right'
      selectedAuditRequest.value = null
      backButtonClicked.value = true
      window.history.go(-1)
    }

    const onModalHashChange = (e: HashChangeEvent) => {
      if (process.client && window.location.hash) {
        if (backButtonClicked.value) {
          e.preventDefault()
          e.stopPropagation()
          backButtonClicked.value = false
          // return
        }
        if (window.location.hash === '#audits') {
          // we just came back to step 1
          swipeDirection.value = 'swipe-right'
          selectedAuditRequest.value = null
        } else {
          const splitLocation = window.location.hash.split('-')
          if (splitLocation.length) {
            const auditId = splitLocation[splitLocation.length - 1]
            if (!splitLocation[splitLocation.length - 1]) {
              return
            }
            swipeDirection.value = 'swipe-left'
            selectedAuditRequest.value = auditRequests.value.find(
              r => r.id === parseInt(auditId)
            ) as AuditRequest
          }
        }
      }
    }

    onMounted(() => {
      modalToggleFunc.setModalInSearch(false)
      modalToggleFunc.setOnHashChangeCallback(onModalHashChange)
    })

    const hideModal = () => {
      if (!loadedAuditRequest.value && selectedAuditRequest.value) {
        // go back to step 1 (list of requests)
        window.history.go(-1)
      }
      emit('close')
    }

    const selfAuditInList = computed(() => {
      if (auditRequests.value) {
        return Boolean(
          auditRequests.value.find(a =>
            userGetters('userIds').includes(a.requestedByUser.id)
          )
        )
      }
      return false
    })
    const handleStatusChange = async () => {
      loading.value = true
      const { auditRequest } = await auditRequestService.getAuditRequestStatus(
        selectedAuditRequest.value.id
      )
      selectedAuditRequest.value = auditRequest
      commit(UPDATE_AUDIT_REQUEST, auditRequest)
      loading.value = false
    }

    const onRequestClick = (request: AuditRequest) => {
      swipeDirection.value = 'swipe-left'
      selectedAuditRequest.value = request
      modalToggleFunc.goToNextHash(`audit-${request.id}`)
    }

    const showSelfAuditButton = computed(() => {
      if (isClassifiedOwner.value) {
        return !selfAuditInList.value
      }

      return false
    })

    const updateSelectedAuditRequest = (updatedRequest: AuditRequest) => {
      commit(UPDATE_AUDIT_REQUEST, updatedRequest)
      selectedAuditRequest.value = updatedRequest
      if (loadedAuditRequest.value) {
        emit('updated-loaded-audit-request', updatedRequest)
      }
    }

    return {
      modalToggleFunc,
      loading,
      hideModal,
      swipeDirection,
      transitioning,
      goBack,
      mainHash,
      faTimes,
      ciAngleLeftLight,
      ciAuditRequest,
      auditRequests,
      auditRequestService,
      selectedAuditRequest,
      handleStatusChange,
      onRequestClick,
      capitalizeSentences,
      minimumPrice,
      selfAuditInList,
      showSelfAuditButton,
      updateSelectedAuditRequest,
      isAdmin
    }
  }
})
